import FadeIn from './fade-in'
import FadeInDown from './fade-in-down'
import FadeInDownBig from './fade-in-down-big'
import FadeInLeft from './fade-in-left'
import FadeInLeftBig from './fade-in-left-big'
import FadeInRight from './fade-in-right'
import FadeInRightBig from './fade-in-right-big'
import FadeInUp from './fade-in-up'
import FadeInUpBig from './fade-in-up-big'

export default {
  FadeIn,
  FadeInDown,
  FadeInDownBig,
  FadeInLeft,
  FadeInLeftBig,
  FadeInRight,
  FadeInRightBig,
  FadeInUp,
  FadeInUpBig
}



// WEBPACK FOOTER //
// ./src/animates/animated-vue/transitions/fading-entrances/index.js